export const inventoryTranslations = {
  en: {
    title: 'Inventory',
    description: 'Manage your products and track inventory levels',
    addProduct: 'Add Product',
    search: 'Search products...',
    noProducts: 'No products found',
    filters: {
      title: 'Filters',
      category: 'Category',
      stockLevel: {
        label: 'Stock Level',
        all: 'All Stock Levels',
        low: 'Low Stock',
        out: 'Out of Stock'
      },
      clearAll: 'Clear all filters'
    },
    form: {
      title: 'Product Details',
      productName: {
        label: 'Product Name',
        placeholder: 'Enter product name'
      },
      sku: {
        label: 'SKU',
        placeholder: 'Enter SKU'
      },
      category: {
        label: 'Category',
        placeholder: 'Select a category'
      },
      unit: {
        label: 'Unit of Measure',
        placeholder: 'e.g., pcs, kg, m'
      },
      minQuantity: {
        label: 'Minimum Quantity',
        placeholder: 'Enter minimum quantity'
      },
      buttons: {
        create: 'Create Product',
        update: 'Update Product',
        cancel: 'Cancel'
      }
    },
    transaction: {
      title: 'Stock Transaction',
      type: {
        in: 'Stock In',
        out: 'Stock Out'
      }
    },
    orders: {
      title: 'Orders',
      description: 'Manage WooCommerce and manual orders',
      newOrder: 'New Order',
      channels: {
        all: 'All Channels',
        woocommerce: 'WooCommerce',
        manual: 'Manual'
      },
      status: {
        draft: 'Draft',
        confirmed: 'Confirmed',
        pending: 'Pending',
        processing: 'Processing',
        onHold: 'On Hold',
        prepared: 'Prepared',
        shipped: 'Shipped',
        completed: 'Completed',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
        failed: 'Failed'
      },
      form: {
        selectClient: 'Select Client',
        importFromDeal: 'Import from Deal (optional)',
        products: 'Products',
        addProducts: 'Add Products',
        shipping: 'Shipping Address',
        sameAsBilling: 'Same as billing address',
        shippingCost: 'Shipping cost',
        shippingMethod: 'Shipping method',
        notes: 'Notes',
        customerNotes: 'Customer notes',
        internalNotes: 'Internal notes',
        review: 'Review',
        createOrder: 'Create Order'
      },
      detail: {
        confirmOrder: 'Confirm Order',
        cancelOrder: 'Cancel Order',
        cancelReason: 'Cancellation reason',
        prepareOrder: 'Prepare Order',
        duplicateOrder: 'Duplicate Order (Quick Reorder)',
        client: 'Client',
        linkedDeal: 'Linked Deal',
        products: 'Products',
        totals: 'Totals',
        subtotal: 'Subtotal',
        discount: 'Discount',
        shipping: 'Shipping',
        tax: 'Tax',
        total: 'Total',
        shippingAddress: 'Shipping Address',
        tracking: 'Tracking',
        timeline: 'Timeline'
      },
      stats: {
        total: 'Total',
        woocommerce: 'WooCommerce',
        manual: 'Manual',
        toProcess: 'To Process'
      },
      empty: {
        title: 'No orders found',
        description: 'Create a new manual order or wait for WooCommerce orders'
      },
      availability: {
        available: 'Available',
        outOfStock: 'Out of Stock',
        insufficientStock: 'Insufficient stock',
        onlyAvailable: 'Only {quantity} available'
      }
    },
    preparation: {
      title: 'Order Preparation',
      description: 'Manage order preparation with scanner (WooCommerce and Manual)',
      stats: {
        toPrepare: 'To Prepare',
        inProgress: 'In Progress',
        totalToday: 'Total Today'
      },
      status: {
        toPrepare: 'To Prepare',
        inPreparation: 'In Preparation'
      },
      actions: {
        start: 'Start',
        continue: 'Continue'
      },
      empty: {
        title: 'No orders to prepare',
        description: 'Orders (WooCommerce and Manual) will appear here when ready for preparation'
      }
    }
  },
  it: {
    title: 'Inventario',
    description: 'Gestisci i tuoi prodotti e monitora i livelli di inventario',
    addProduct: 'Aggiungi Prodotto',
    search: 'Cerca prodotti...',
    noProducts: 'Nessun prodotto trovato',
    filters: {
      title: 'Filtri',
      category: 'Categoria',
      stockLevel: {
        label: 'Livello Scorte',
        all: 'Tutti i Livelli',
        low: 'Scorte Basse',
        out: 'Esaurito'
      },
      clearAll: 'Cancella tutti i filtri'
    },
    form: {
      title: 'Dettagli Prodotto',
      productName: {
        label: 'Nome Prodotto',
        placeholder: 'Inserisci nome prodotto'
      },
      sku: {
        label: 'SKU',
        placeholder: 'Inserisci SKU'
      },
      category: {
        label: 'Categoria',
        placeholder: 'Seleziona una categoria'
      },
      unit: {
        label: 'Unità di Misura',
        placeholder: 'es. pz, kg, m'
      },
      minQuantity: {
        label: 'Quantità Minima',
        placeholder: 'Inserisci quantità minima'
      },
      buttons: {
        create: 'Crea Prodotto',
        update: 'Aggiorna Prodotto',
        cancel: 'Annulla'
      }
    },
    transaction: {
      title: 'Movimento di Magazzino',
      type: {
        in: 'Carico',
        out: 'Scarico'
      }
    },
    orders: {
      title: 'Ordini',
      description: 'Gestisci ordini WooCommerce e manuali',
      newOrder: 'Nuovo Ordine',
      channels: {
        all: 'Tutti i Canali',
        woocommerce: 'WooCommerce',
        manual: 'Manuali'
      },
      status: {
        draft: 'Bozza',
        confirmed: 'Confermato',
        pending: 'In attesa',
        processing: 'In lavorazione',
        onHold: 'In sospeso',
        prepared: 'Preparato',
        shipped: 'Spedito',
        completed: 'Completato',
        cancelled: 'Annullato',
        refunded: 'Rimborsato',
        failed: 'Fallito'
      },
      form: {
        selectClient: 'Seleziona Cliente',
        importFromDeal: 'Importa da offerta (opzionale)',
        products: 'Prodotti',
        addProducts: 'Aggiungi Prodotti',
        shipping: 'Indirizzo di Spedizione',
        sameAsBilling: 'Stesso indirizzo di fatturazione',
        shippingCost: 'Costo di spedizione',
        shippingMethod: 'Metodo di spedizione',
        notes: 'Note',
        customerNotes: 'Note per il cliente',
        internalNotes: 'Note interne',
        review: 'Riepilogo',
        createOrder: 'Crea Ordine'
      },
      detail: {
        confirmOrder: 'Conferma Ordine',
        cancelOrder: 'Annulla Ordine',
        cancelReason: 'Motivo annullamento',
        prepareOrder: 'Prepara Ordine',
        duplicateOrder: 'Duplica Ordine (Riordino Rapido)',
        client: 'Cliente',
        linkedDeal: 'Offerta Collegata',
        products: 'Prodotti',
        totals: 'Totali',
        subtotal: 'Subtotale',
        discount: 'Sconto',
        shipping: 'Spedizione',
        tax: 'IVA',
        total: 'Totale',
        shippingAddress: 'Indirizzo di Spedizione',
        tracking: 'Tracciamento',
        timeline: 'Cronologia'
      },
      stats: {
        total: 'Totale',
        woocommerce: 'WooCommerce',
        manual: 'Manuali',
        toProcess: 'Da Processare'
      },
      empty: {
        title: 'Nessun ordine trovato',
        description: 'Crea un nuovo ordine manuale o attendi ordini da WooCommerce'
      },
      availability: {
        available: 'Disponibile',
        outOfStock: 'Esaurito',
        insufficientStock: 'Stock insufficiente',
        onlyAvailable: 'Disponibili solo {quantity}'
      }
    },
    preparation: {
      title: 'Preparazione Ordini',
      description: 'Gestisci la preparazione ordini con scanner (WooCommerce e Manuali)',
      stats: {
        toPrepare: 'Da Preparare',
        inProgress: 'In Preparazione',
        totalToday: 'Totale Oggi'
      },
      status: {
        toPrepare: 'Da Preparare',
        inPreparation: 'In Preparazione'
      },
      actions: {
        start: 'Inizia',
        continue: 'Continua'
      },
      empty: {
        title: 'Nessun ordine da preparare',
        description: 'Gli ordini (WooCommerce e Manuali) appariranno qui quando saranno pronti per la preparazione'
      }
    }
  }
};